import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoRacion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_racion',
        name: 'Tipo Racion',
        component: ViewTipoRacion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
